import React, { useState, useEffect } from "react";

const CardListDetails = (props) => {
  const [cardImage, setCardImage] = useState("");
  const [cardDetails, setCardDetails] = useState(props.items);
  useEffect(() => {
    if (cardDetails.brand === "Visa") {
      setCardImage("https://thumbs.dreamstime.com/b/web-183282979.jpg");
    } else if (cardDetails.brand === "MasterCard") {
      setCardImage(
        "https://seeklogo.com/images/M/master-card-logo-5806741801-seeklogo.com.png"
      );
    } else if (cardDetails.brand === "American Express") {
      setCardImage(
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR3hrUiWKoJ7x-ZPqEGH6J3cmKJybb20K4XSFYrrrVmw9QRO7UlqY8n1_Bxg46myDUgLW4&usqp=CAU"
      );
    } else if (cardDetails.brand === "Discover") {
      setCardImage(
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmRYzSUSRhR5UnWmSZwE_5zDMjzDXgUes5U9IIj8spkmPpGGvoSqaotwjB0MU8J-Uh42w&usqp=CAU"
      );
    } else if (cardDetails.brand === "Visa") {
      setCardImage(
        "https://www.sketchappsources.com/resources/source-image/PayPalCard.png"
      );
    }
  }, []);

  return (
    <div key={props.id}>
      <div className="card_list">
        <div className="card  p-3 mx-3 my-3">
          <div className="img-box">
            <img src={cardImage} alt="CardImage" />
          </div>
          <div className="number">
            <label
              className="fw-bold"
              htmlFor=""
              style={{
                fontSize: "80%",
                fontFamily: "GibsonRegular",
              }}
            >
              **** **** **** {cardDetails.last4}
            </label>
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <small>
              <span
                className="fw-bold"
                style={{
                  fontSize: "100%",
                  fontFamily: "GibsonRegular",
                }}
              >
                Expiry date:
              </span>
              <span
                style={{
                  fontSize: "100%",
                  fontFamily: "GibsonRegular",
                }}
              >
                {cardDetails.exp_month}/{cardDetails.exp_year}
              </span>
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardListDetails;
